import { mixpanelTrack } from "./mixpanelTrack";

// Squad-Builder client-side Mixpanel events. Pure-client interactions (no API
// round-trip) live here; data-mutating actions (build/save/load/import/share/
// tactics-code) are fired server-side in peareasy-services instead.
//
// Mirrors events/sbcMixpanel.ts: routes through the shared mixpanelTrack
// helper, a SECTION constant, and one track* fn per event. Squad Builder has a
// single subsection ("Normal").

const SECTION = "Squad Builder";

type SquadBuilderSubsection = "Normal";

const NO_BUDGET = Number.MAX_VALUE;

// Active-filter "keys" (names without values) for player_recs_chosen. Derived
// from activeFiltersSelector output; budget and scope are reported as their own
// props so they are excluded here.
const FILTER_KEY_LABELS: Record<string, string> = {
  country: "Country",
  league: "League",
  rarity: "Version",
  clubs: "Club",
  pastAndPresentClub: "Past & Present Club",
  metal: "Metal",
  playerFilter: "Player Filters",
};

export const squadBuilderFilterKeys = (
  activeFilters: { key: string }[],
  scope: string,
): string[] =>
  activeFilters
    .filter((f) => f.key !== "budget" && f.key !== scope)
    .map((f) => FILTER_KEY_LABELS[f.key] ?? f.key);

export const trackPlayerRecsChosen = (params: {
  scope: string;
  filters: string[];
  budget: number;
  position?: string;
  subsection?: SquadBuilderSubsection;
}) => {
  // Disabled for now.
  // mixpanelTrack("player_recs_chosen", {
  //   section: SECTION,
  //   subsection: params.subsection ?? "Normal",
  //   scope: params.scope,
  //   filters: params.filters,
  //   budget: params.budget < NO_BUDGET ? params.budget : null,
  //   position: params.position,
  //   action_type: "core",
  // });
};

export const trackViewContent = (
  subsection: SquadBuilderSubsection = "Normal",
) => {
  mixpanelTrack("view_content", {
    section: SECTION,
    subsection,
    content_type: "player",
    new_content: false,
    action_type: "browse",
  });
};

export const trackExplore = (subsection: SquadBuilderSubsection = "Normal") =>
  mixpanelTrack("explore", {
    section: SECTION,
    subsection,
    source: "browse tactics",
    destination_section: "Tactics",
    destination_subsection: "Overview",
    new_content: false,
    action_type: "browse",
  });

export const trackAddedPlayerToEvolutionBuilder = (
  subsection: SquadBuilderSubsection = "Normal",
) =>
  mixpanelTrack("added_player_to_evolution_builder", {
    section: SECTION,
    subsection,
    action_type: "browse",
  });
